import { render } from "./OnlineBookingHistory.vue?vue&type=template&id=66a06670&scoped=true"
import script from "./OnlineBookingHistory.vue?vue&type=script&lang=js"
export * from "./OnlineBookingHistory.vue?vue&type=script&lang=js"

import "./OnlineBookingHistory.vue?vue&type=style&index=0&id=66a06670&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a06670"]])

export default __exports__